import React, { useState } from 'react';
import { Table, Button, Form, Row, Col, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaStar, FaRegStar, FaTrash } from 'react-icons/fa';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import * as api from '~/Services/Service';
import ModalAdicionarParticipante from '../Modais/ModalAdicionarParticipante';

const FILTRO_TODOS = 'todos';
const FILTRO_T = 'T';
const FILTRO_U = 'U';

const TabParticipantes = (props) => {
  const parceria = props.parceria;
  const onAlterado = props.onAlterado;
  const participantes = (parceria && parceria.participantes) || [];

  const [filtroTipo, setFiltroTipo] = useState(FILTRO_TODOS);
  const [showModal, setShowModal] = useState(false);
  const [confirmacao, setConfirmacao] = useState({ show: false, item: null, acao: null });

  const participantesFiltrados = filtroTipo === FILTRO_TODOS
    ? participantes
    : participantes.filter((p) => p.tipo === filtroTipo);

  const handleMarcarLoteador = (item) => {
    setConfirmacao({
      show: true,
      item: item,
      acao: 'loteador',
    });
  };

  const handleExcluir = (item) => {
    setConfirmacao({
      show: true,
      item: item,
      acao: 'excluir',
    });
  };

  const handleConfirmar = async (confirmado) => {
    const { item, acao } = confirmacao;
    setConfirmacao({ show: false, item: null, acao: null });
    if (!confirmado || !item) return;

    try {
      if (acao === 'loteador') {
        await api.marcarLoteadorParceria({
          codigo_parceria: parceria.codigo_parceria,
          codigo_grupo_empresa: item.codigo_grupo_empresa,
        });
        toast.success('Loteador marcado com sucesso');
      } else if (acao === 'excluir') {
        await api.excluirParticipanteParceria({
          codigo_parceria: parceria.codigo_parceria,
          codigo_grupo_empresa: item.codigo_grupo_empresa,
        });
        toast.success('Participante removido com sucesso');
      }
      await onAlterado();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao executar ação');
    }
  };

  const mensagemConfirmacao = () => {
    if (!confirmacao.item) return '';
    if (confirmacao.acao === 'loteador') {
      return 'Deseja marcar "' + confirmacao.item.apelido + '" como Loteador? O loteador anterior será desmarcado.';
    }
    return 'Deseja remover o participante "' + confirmacao.item.apelido + '" desta parceria?';
  };

  return (
    <div>
      <Row className="align-items-center mb-3">
        <Col>
          <Form.Group className="mb-0 d-flex align-items-center">
            <Form.Label className="mb-0 mr-3 font-weight-bold">Filtrar:</Form.Label>
            {[
              { value: FILTRO_TODOS, label: 'Todos' },
              { value: FILTRO_T, label: 'Terreneiros' },
              { value: FILTRO_U, label: 'Urbanizadoras' },
            ].map((op) => (
              <Form.Check
                key={op.value}
                inline
                type="radio"
                label={op.label}
                name="filtroTipo"
                id={'filtro-' + op.value}
                value={op.value}
                checked={filtroTipo === op.value}
                onChange={() => setFiltroTipo(op.value)}
                className="mr-3"
              />
            ))}
          </Form.Group>
        </Col>
        <Col className="text-right">
          <Button variant="primary" onClick={() => setShowModal(true)}>
            + Adicionar Participante
          </Button>
        </Col>
      </Row>

      {participantesFiltrados.length === 0 ? (
        <p className="text-muted text-center my-3">Nenhum participante adicionado.</p>
      ) : (
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th style={{ width: '80px', textAlign: 'center' }}>Loteador</th>
              <th style={{ width: '70px', textAlign: 'center' }}>Tipo</th>
              <th>GE</th>
              <th>Apelido</th>
              <th style={{ width: '90px', textAlign: 'center' }}>% Part.</th>
              <th style={{ width: '110px', textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {participantesFiltrados.map((item) => (
              <tr key={item.codigo_grupo_empresa + '-' + item.tipo}>
                <td className="text-center">
                  {item.padrao === 'S' ? (
                    <FaStar style={{ color: '#f5a623' }} title="Loteador" />
                  ) : (
                    <FaRegStar style={{ color: '#ccc' }} />
                  )}
                </td>
                <td className="text-center">
                  <Badge variant={item.tipo === 'T' ? 'info' : 'secondary'}>
                    {item.tipo === 'T' ? 'Terreneiro' : 'Urbanizadora'}
                  </Badge>
                </td>
                <td>{item.codigo_grupo_empresa}</td>
                <td>{item.apelido}</td>
                <td className="text-center">
                  {item.percentual != null ? item.percentual + '%' : '—'}
                </td>
                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                  {item.padrao !== 'S' && (
                    <Button
                      variant="outline-warning"
                      title="Marcar como Loteador"
                      className="mr-1"
                      onClick={() => handleMarcarLoteador(item)}
                    >
                      <FaStar />
                    </Button>
                  )}
                  <Button
                    variant="outline-danger"
                    title="Remover"
                    onClick={() => handleExcluir(item)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <ModalAdicionarParticipante
        show={showModal}
        onHide={() => setShowModal(false)}
        codigoParceria={parceria.codigo_parceria}
        participantesExistentes={participantes}
        onSalvo={async () => {
          setShowModal(false);
          await onAlterado();
        }}
      />

      <ModalConfirmacao
        show={confirmacao.show}
        title={confirmacao.acao === 'loteador' ? 'Marcar Loteador' : 'Remover Participante'}
        message={mensagemConfirmacao()}
        onClose={handleConfirmar}
      />
    </div>
  );
};

export default TabParticipantes;
